import { handleActions } from 'redux-actions';
import { updateApplicationStatusByCodeSuccess } from '../actions/applications';
import { denyReservableSuccess, getApartmentsShowingsSuccess, getReserveData, getReserveDataFail, getReserveDataSuccess, getShowingsSuccess, reserveShowingSuccess, getUserShowingsSuccess, getShowings, getApartmentsShowings, getShowingsFail, getApartmentsShowingsFail, getUserShowings, getUserShowingsFail, addShowingToFieldArrayFail, addShowingToFieldArraySuccess, getOpenShowingsSuccess
// createShowings,
 } from '../actions/showings';
import { ReserveData } from '../types/showings';
import { ShowingsState } from '../types/states';
import { Action, ActionWithPayload } from './types';
const initialState: ShowingsState = {
    showingsInterfaces: {},
    openShowings: {},
    reserve: {
        loading: false,
        reserveViewLogic: {
            bestReservableIndex: 0,
            bestReservableAmount: 0,
            reservableIndex: 0,
            reservableAmount: 0,
            loopedThrough: false
        }
    },
    loading: false,
    error: null
};
const showingsReducer = handleActions({
    // [createShowings]: () => initialState,
    [getShowings]: (state: ShowingsState) => ({
        ...state,
        loading: true
    }),
    [getShowingsSuccess]: (state, { payload: { apartmentId, showingsInterface } }: Action) => ({
        ...state,
        showingsInterfaces: {
            ...state.showingsInterfaces,
            [apartmentId]: showingsInterface
        },
        loading: false
    }),
    [getShowingsFail]: (state: ShowingsState) => ({
        ...state,
        loading: false
    }),
    [getApartmentsShowings]: (state: ShowingsState) => ({
        ...state,
        loading: true
    }),
    [getApartmentsShowingsSuccess]: (state: ShowingsState, { payload: indexedShowingsInterfaces }: any) => ({
        ...state,
        showingsInterfaces: indexedShowingsInterfaces,
        loading: false
    }),
    [getApartmentsShowingsFail]: (state: ShowingsState) => ({
        ...state,
        loading: false
    }),
    [getUserShowings]: (state: ShowingsState) => ({
        ...state,
        loading: true
    }),
    [getUserShowingsSuccess]: (state: ShowingsState, { payload: indexedShowingsInterfaces }: any) => ({
        ...state,
        showingsInterfaces: indexedShowingsInterfaces,
        loading: false
    }),
    [getUserShowingsFail]: (state: ShowingsState) => ({
        ...state,
        loading: false
    }),
    [getReserveData]: (state: ShowingsState) => ({
        ...state,
        reserve: {
            ...state.reserve,
            loading: true,
            reserveViewLogic: {
                bestReservableIndex: 0,
                bestReservableAmount: 0,
                reservableIndex: 0,
                reservableAmount: 0,
                loopedThrough: false
            }
        }
    }),
    [getReserveDataSuccess]: (state: ShowingsState, { payload: reserveData }: ActionWithPayload<ReserveData>) => ({
        ...state,
        reserve: {
            ...state.reserve,
            reserveData,
            loading: false,
            reserveViewLogic: {
                ...state.reserve.reserveViewLogic,
                reservableAmount: reserveData.reservableShowings.reservables.length,
                bestReservableAmount: reserveData.reservableShowings.bestReservables.length
            }
        }
    }),
    [getReserveDataFail]: (state: ShowingsState, { payload: errorNum }: Action) => ({
        ...state,
        reserve: {
            ...state.reserve,
            loading: false,
            reserveViewLogic: {
                reserved: errorNum === '409',
                error: errorNum
            }
        }
    }),
    [denyReservableSuccess]: (state: ShowingsState, { payload: reserveViewLogic }: Action) => ({
        ...state,
        reserve: {
            ...state.reserve,
            reserveViewLogic: {
                ...state.reserve.reserveViewLogic,
                ...reserveViewLogic
            }
        }
    }),
    [reserveShowingSuccess]: (state: ShowingsState, { payload: reserveData }: Action) => ({
        ...state,
        reserve: {
            ...state.reserve,
            reserveData
        }
    }),
    [updateApplicationStatusByCodeSuccess]: (state: ShowingsState, { payload: reserveData }: Action) => ({
        ...state,
        reserve: {
            ...state.reserve,
            reserveData
        }
    }),
    [addShowingToFieldArrayFail]: (state: ShowingsState, { payload }: Action) => ({
        ...state,
        error: payload.errors._error
    }),
    [addShowingToFieldArraySuccess]: (state: ShowingsState) => ({
        ...state,
        error: null as null
    }),
    // Avoimet asuntonäytöt
    [getOpenShowingsSuccess]: (state: ShowingsState, { payload }: any) => ({
        ...state,
        openShowings: { ...state.openShowings, [payload.apartmentId]: payload.showings }
    }),
}, initialState);
export default showingsReducer;
